

import CommonApi from './../commonApi';

const maintenanceCostAllocation = new CommonApi(
  'maintenanceCostAllocation',
  'Распределение затрат на ТО'
);

export default {
  ...maintenanceCostAllocation
};
